import { RootState } from "../../store";

export const globalLoadingSelector = (state: RootState) => {
    return state.globalLoading.loading;
};
